import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { StoreProvider } from 'easy-peasy';
import { SemanticToastContainer } from 'react-semantic-toasts';
import 'semantic-ui-css/semantic.min.css';

import store from './store';
import * as serviceWorker from './serviceWorker';
import AuthenticatedRoute from './components/AuthenticatedRoute';
import routes from './services/router/routes';
import LoadingState from './components/LoadingState';

localStorage.setItem('debug', process.env.REACT_APP_DEBUG);

const container = document.getElementById('root');

const root = createRoot(container);

const app = (
  <StoreProvider store={store}>
    <BrowserRouter>
      <Suspense fallback={<LoadingState />}>
        <SemanticToastContainer position="top-right" />
        <Switch>
          {routes.map((route, i) => {
            if (route.hasOwnProperty('meta') && route.meta.noAuth) {
              return <Route key={i} {...route} />;
            }

            return <AuthenticatedRoute key={i} {...route} />;
          })}
        </Switch>
      </Suspense>
    </BrowserRouter>
  </StoreProvider>
);

root.render(app);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
